import { render, staticRenderFns } from "./ResponsesSuccessfullyDeletedView.vue?vue&type=template&id=07c5ad38&scoped=true"
import script from "./ResponsesSuccessfullyDeletedView.vue?vue&type=script&lang=js"
export * from "./ResponsesSuccessfullyDeletedView.vue?vue&type=script&lang=js"
import style0 from "./ResponsesSuccessfullyDeletedView.vue?vue&type=style&index=0&id=07c5ad38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c5ad38",
  null
  
)

export default component.exports